import { render, staticRenderFns } from "./BagIcon.vue?vue&type=template&id=39dc5af3"
import script from "./BagIcon.vue?vue&type=script&lang=js"
export * from "./BagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports